import TreeItem from './component';
import enhance from './enhancer';

const EnhancedTreeItem = enhance(TreeItem);

export { EnhancedTreeItem as default, TreeItem };
